module.exports = __webpack_public_path__ + "media/C.9650b317.mp3";